/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhrecht8Inputs */

const en__field_enum_ikhrecht8 = /** @type {(inputs: _Field_Enum_Ikhrecht8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01 - Rechtswissenschaft`)
};

const de__field_enum_ikhrecht8 = /** @type {(inputs: _Field_Enum_Ikhrecht8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01 - Rechtswissenschaft`)
};

/**
* | output |
* | --- |
* | "01 - Rechtswissenschaft" |
*
* @param {_Field_Enum_Ikhrecht8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhrecht8 = /** @type {((inputs?: _Field_Enum_Ikhrecht8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhrecht8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhrecht8(inputs)
	return de__field_enum_ikhrecht8(inputs)
});
export { _field_enum_ikhrecht8 as "_field_enum_IKHRECHT" }